export enum TabName {
  NEW = 'new_users_amount',
  ENGAGED = 'engaged_users_amount',
  DISENGAGED = 'disengaged_users_amount',
  NOT_VINCULATED = 'unlinked_users_amount',
  NOT_INITIALIZED = 'not_started_users_amount',
  WARNING = 'warning_users_amount',
  FINISHING_PROGRAM = 'finishing_program_users_amount',
}

export enum TabType {
  LARGE = 'large',
  SMALL = 'small',
}

export enum TabState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DISABLED = 'disabled',
}

export type TabData = {
  name: TabName;
  type: TabType;
  keyName: string;
  amount?: number;
  state?: TabState;
};

export interface TCDashboardTabProps {
  type: string;
  name: TabName;
  keyName: string;
  state: TabState;
  amount?: number;
  onSelect: (tabName: TabName) => void;
}

export interface TabContainerProps {
  state: TabState;
}
